import { t } from '../../app/i18n';

export default {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
};

export const translation = {
  MALE: t('Muž'),
  FEMALE: t('Žena'),
};



// WEBPACK FOOTER //
// ./src/common/enums/genders.js